export default function ({ redirect, route, localePath, app }) {
  if (app.i18n.localeProperties.code !== 'fr') {
    if (route.fullPath === '/connexion') {
      return redirect(localePath({ name: 'connexion' }))
    }

    if (route.fullPath === '/compte') {
      return redirect(localePath({ name: 'compte' }))
    }

    if (route.fullPath === '/') {
      return redirect(localePath({ name: 'index' }))
    }
  }
}
